import {doc, updateDoc} from 'firebase/firestore';
import {db} from '../firebaseConfig';
import {firestoreCollections} from './firestoreConstants';

/**
 * Hides a traveler from the Assembly task list by setting the persisted hide flag.
 *
 * Firestore errors are allowed to propagate so the caller can roll back any optimistic UI update.
 */
export async function hideTravelerFromAssemblyTaskList(travelerId: string): Promise<void> {
  const travelerRef = doc(db, firestoreCollections.travelers, travelerId);
  await updateDoc(travelerRef, {hideFromAssemblyTaskList: true});
}
